import React from 'react';
import { Steps } from 'antd';
import PropTypes from 'prop-types';
import { ReactComponent as Check } from 'assets/icons/check.svg';

const { Step } = Steps;

const CustomSteps = ({ steps, current, setCurrent, ...rest }) => {
  const Component = steps[current].Component;

  return (
    <>
      <div className="custom-stepper">
        <Steps current={current} {...rest}>
          {steps.map((item, index) => {
            if(item.active === true){
            return (
              <Step
                icon={
                  current > index ? (
                    <Check width={'14px'} heigt={'14px'} />
                  ) : null
                }
                key={index}
                title={item.title}
                onClick={() => setCurrent(index)}
              />
            );
            }
          })}
        </Steps>
        <Component />
      </div>
    </>
  );
};

CustomSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      Component: PropTypes.func.isRequired,
    })
  ),
  current: PropTypes.number.isRequired,
  setCurrent: PropTypes.func.isRequired,
};

export default CustomSteps;
